import { apiRequestGet, apiRequestPost } from 'mastodon/api';

import type { ApiNewsItemJSON } from '../api_types/news';

export const apiGetNewsItems = (params?: { max_id?: string }) =>
  apiRequestGet<ApiNewsItemJSON[]>('v1/timelines/news', params);

export const apiGetFavouritedNewsItems = (params?: { max_id?: string }) =>
  apiRequestGet<ApiNewsItemJSON[]>('v1/news_item_favourites', params);

export const apiFavouriteNewsItem = (id: string) =>
  apiRequestPost<ApiNewsItemJSON>(`v1/news_items/${id}/favourite`);

export const apiUnfavouriteNewsItem = (id: string) =>
  apiRequestPost<ApiNewsItemJSON>(`v1/news_items/${id}/unfavourite`);

export const apiRepostNewsItem = (id: string, text?: string) =>
  apiRequestPost<ApiNewsItemJSON>(
    `v1/news_items/${id}/repost`,
    text ? { text } : undefined,
  );

export const apiUnrepostNewsItem = (id: string) =>
  apiRequestPost<ApiNewsItemJSON>(`v1/news_items/${id}/unrepost`);
